export default __webpack_public_path__ + "static/media/NAV.c315c432.svg";